let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1YvQ0")).then(() => parcelRequire('6CsZV'));